<template>
  <div class="banner">
    <img src="../../../assets/enroll/bg.png" alt="" class="bg" />
    <div class="mask"></div>
    <img src="../../../assets/enroll/slogan.png" alt="" class="slogan" />
  </div>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: calc(100vw / 1920 * 384);
  min-height: 300px;

  .bg {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .mask {
    position: absolute;
    top: 0;
    width: 100%;
    height: calc(100vw / 1920 * 264);
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    opacity: 0.3;
  }
  .slogan {
    position: absolute;
    top: calc(100vw / 1920 * 105);
    left: 0;
    right: 0;
    width: calc(100vw / 1920 * 792);
    min-width: 400px;
    max-width: 80%;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 600px) {
  .banner {
    height: 220px;
    min-height: unset;
    .mask {
      height: 80px;
    }
    .slogan {
      min-width: unset;
      top: 50px;
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>